import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-building-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2384)">
        <path
          d="M7.59799 23.25V19.337"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.467 23.25V19.337"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.64099 19.337H15.424"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 23.25V6.958C0.762707 6.6919 0.880337 6.44169 1.07713 6.26213C1.27393 6.08258 1.53386 5.98832 1.8 6H10.2C10.4661 5.98832 10.7261 6.08258 10.9229 6.26213C11.1197 6.44169 11.2373 6.6919 11.25 6.958V15.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 3.5C8.24124 3.35937 8.17725 3.22791 8.07198 3.13425C7.96671 3.04059 7.82869 2.99234 7.688 3H4.313C4.17214 2.99207 4.03386 3.0402 3.92838 3.13388C3.82289 3.22757 3.75876 3.35919 3.75 3.5V6H8.25V3.5Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.97699 2.706L5.99999 0.913"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 9.75H8.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 14.25H8.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 23.25H23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5 16.5C21.5711 16.5 23.25 14.8211 23.25 12.75C23.25 10.6789 21.5711 9 19.5 9C17.4289 9 15.75 10.6789 15.75 12.75C15.75 14.8211 17.4289 16.5 19.5 16.5Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.5 23.25V13.5"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2384">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessBuildingInsuranceIconComponent extends BaseIconComponent {}
